var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "skill-card",
    style: _vm.cardStyle
  }, [_c("img", {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: require(`@/assets/images/homepage/${_vm.img}`),
      expression: "require(`@/assets/images/homepage/${img}`)"
    }],
    staticClass: "icon-strengths",
    attrs: {
      alt: "strengths"
    }
  }), _c("h4", [_vm._v(_vm._s(_vm.title))]), _c("div", {
    staticClass: "line"
  }), _c("p", {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.desc))])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };